import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Info, Layers, ShieldCheck, PhoneCall } from "lucide-react";

const navTabs = [
  { label: "Home", path: "/", icon: Home },
  { label: "About Us", path: "/aboutus", icon: Info },
  { label: "Products", path: "/products", icon: Layers },
  { label: "Quality", path: "/quality-control", icon: ShieldCheck },
  { label: "Contact", path: "/contact-us", icon: PhoneCall },
];

const MobileBottomNav = () => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] px-1 py-1.5 flex items-center justify-around select-none">
      {navTabs.map((tab) => {
        const Icon = tab.icon;
        const isActive =
          tab.path === "/"
            ? location.pathname === "/"
            : location.pathname.startsWith(tab.path);

        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`flex flex-col items-center justify-center py-1 px-1.5 rounded-xl transition-all duration-200 relative ${
              isActive
                ? "text-[#12385a] font-bold"
                : "text-slate-600 hover:text-slate-800 font-medium"
            }`}
          >
            {/* Active Indicator Pill */}
            {isActive && (
              <span className="absolute -top-1.5 w-5 h-1 bg-amber-500 rounded-full animate-fade-in" />
            )}
            <div
              className={`p-0.5 rounded-lg transition-transform ${
                isActive ? "scale-110 text-[#12385a]" : ""
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 1.8} />
            </div>
            <span className="text-[10px] tracking-tight whitespace-nowrap">{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
